import { gmRequest } from './index';

export default {
  getRedirect: (path) => gmRequest(`/api/v1/url/redirect?oldpath=${path}`, {}, false),
};
